import React from 'react';
import { Navbar, Nav, Container, Row, Col, Footer } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../tps.css";
const UIFooter = () => {
    return (
        <footer className="text-white fixed-bottom footer-container">
            <Container className="d-flex justify-content-center align-items-center py-3">
                    <div className="container-fluid d-flex justify-content-center">
                        <p className="text-end mb-0 content-footer">
                            &copy; {new Date().getFullYear()} Technical Paper Submission. All rights reserved.
                        </p>
                    </div>
            </Container>
        </footer>

    );
};



export default UIFooter;